// S ::: 180x180 시간표 담당강사 용 작은 이미지 ::: S
import VLAZESmallImage from "../assets/images/smallLogo/small-vlaze.png";
import WARISmallImage from "../assets/images/smallLogo/small-whatdowwari.png";

import BUMBLEBSmallImage from "../assets/images/smallLogo/small-bumbleb.png";
import EUNHYESmallImage from "../assets/images/smallLogo/small-eunhye.png";
import DAYEONSmallImage from "../assets/images/smallLogo/small-dayeon.png";

import HONEYBEESmallImage from "../assets/images/smallLogo/small-honeybee.png";
import KYURISmallImage from "../assets/images/smallLogo/small-kyuri.png";
import WannoSmallImage from "../assets/images/smallLogo/small-wanno.png";
import JAEHUNSmallImage from "../assets/images/smallLogo/small-jaehun.png";
// E ::: 180x180 시간표 담당강사 용 작은 이미지 ::: E

// S ::::: 스케쥴 ::::: S
export const scheduleList = [
  {
    dayEn: "MON",
    dayKo: "월",
    class: [
      {
        time: "7:00 PM",
        title: "셔플 Level.1",
        instructor: "KYURI",
      },
      {
        time: "8:00 PM",
        title: "셔플 Level.2",
        instructor: "KYURI",
      },
      {
        time: "9:00 PM",
        title: "힙합 비기너",
        instructor: "BUMBLE.B",
      },
    ],
  },
  {
    dayEn: "TUE",
    dayKo: "화",
    class: [
      {
        time: "8:00 PM",
        title: "셔플 안무반 (초급)",
        instructor: "KYURI",
      },
    ],
  },
  {
    dayEn: "WED ",
    dayKo: "수",
    class: [
      {
        time: "8:00 PM",
        title: "셔플&풋워크 Level.3",
        instructor: "EUN HYE",
      },
      {
        time: "9:00 PM",
        title: "레트로 케이팝",
        instructor: "DAYEON",
      },
    ],
  },
  {
    dayEn: "THU",
    dayKo: "목",
    class: [
      {
        time: "7:00 PM",
        title: "셔플&풋워크 Level.4",
        instructor: "VLAZE",
      },
      {
        time: "8:00 PM",
        title: "풋워크 테크닉",
        instructor: "VLAZE",
      },
      {
        time: "9:00 PM",
        title: "하우스 비기너",
        instructor: "JAE HUN",
      },
    ],
  },
  {
    dayEn: "SAT",
    dayKo: "토",
    class: [
      {
        time: "10:00 AM",
        title: "셔플 Level.1",
        instructor: "KYURI",
      },
      {
        time: "11:00 AM",
        title: "셔플 Level.2",
        instructor: "KYURI",
      },
      {
        time: "12:00 PM",
        title: "셔플&풋워크 Level.4",
        instructor: "VLAZE",
      },

      {
        time: "1:00 PM",
        title: "셔플&풋워크 Level.3",
        instructor: "EUN HYE",
      },
      {
        time: "2:00 PM",
        title: "셔플&풋워크 안무반 (중급)",
        instructor: "EUN HYE",
      },
      {
        time: "3:00 PM",
        title: "하우스 비기너",
        instructor: "JAE HUN",
      },
      {
        time: "4:00 PM",
        title: "풋워크 테크닉",
        instructor: "VLAZE",
      },
      {
        time: "5:00 PM",
        title: "리듬&베이스 트레이닝",
        instructor: "WHATDOWWARI",
      },
    ],
  },
  {
    dayEn: "SUN",
    dayKo: "일",
    class: [
      {
        time: "11:00 AM",
        title: "풋워크 테크닉",
        instructor: "VLAZE",
      },
      {
        time: "1:00 PM",
        title: "셔플 Level.2",
        instructor: "EUN HYE",
      },
    ],
  },
];
// E ::::: 스케쥴 ::::: E

// S ::::: 셔플 스케쥴 ::::: S
export const shuffleScheduleList = [
  {
    dayEn: "LEVEL.1",
    dayKo: "입문",
    class: [
      {
        time: "",
        title: "월 MON 7:00 PM",
        instructor: "KYURI",
      },

      {
        time: "",
        title: "토 SAT 10:00 AM",
        instructor: "KYURI",
      },
    ],
  },
  {
    dayEn: "LEVEL.2",
    dayKo: "초급",
    class: [
      {
        time: "",
        title: "월 MON 8:00 PM",
        instructor: "KYURI",
      },
      {
        time: "",
        title: "토 SAT 11:00 AM",
        instructor: "KYURI",
      },
      {
        time: "",
        title: "일 SUN 1:00 PM",
        instructor: "EUN HYE",
      },
    ],
  },
  {
    dayEn: "SHUFFLE&FOOTWORK CHOREO",
    dayKo: "셔플&풋워크 안무반",
    class: [
      {
        time: "",
        title: "화 TUE 8:00 PM (초급)",
        instructor: "KYURI",
      },
      {
        time: "",
        title: "토 SAT 2:00 PM (중급)",
        instructor: "EUN HYE",
      },
    ],
  },
  {
    dayEn: "LEVEL.3",
    dayKo: "중급",
    class: [
      {
        time: "",
        title: "수 WED 8:00 PM",
        instructor: "EUN HYE",
      },
      {
        time: "",
        title: "토 SAT 1:00 PM",
        instructor: "EUN HYE",
      },
    ],
  },
  {
    dayEn: "LEVEL.4",
    dayKo: "마스터",
    class: [
      {
        time: "",
        title: "목 THU 7:00 PM",
        instructor: "VLAZE",
      },
      {
        time: "",
        title: "토 SAT 12:00 PM",
        instructor: "VLAZE",
      },
    ],
  },
  {
    dayEn: "FOOTWORK TECHNIQUE",
    dayKo: "풋워크 테크닉",
    class: [
      {
        time: "",
        title: "목 THU 8:00 PM",
        instructor: "VLAZE",
      },
      {
        time: "",
        title: "토 SAT 4:00 PM",
        instructor: "VLAZE",
      },
      {
        time: "",
        title: "일 SUN 11:00 AM",
        instructor: "VLAZE",
      },
    ],
  },
];
// E ::::: 셔플 스케쥴 ::::: E

// S ::: 스케쥴 강사 리스트 ::: S
export const scheduleInstructorsList = [
  {
    name: "VLAZE",
    smallImg: VLAZESmallImage,
  },

  {
    name: "EUN HYE",
    smallImg: EUNHYESmallImage,
  },

  {
    name: "WHATDOWWARI",
    smallImg: WARISmallImage,
  },
  {
    name: "BUMBLE.B",
    smallImg: BUMBLEBSmallImage,
  },

  {
    name: "JAE HUN",
    smallImg: JAEHUNSmallImage,
  },
  {
    name: "KYURI",
    smallImg: KYURISmallImage,
  },
  {
    name: "HONEYBEE",
    smallImg: HONEYBEESmallImage,
  },
  {
    name: "DAYEON",
    smallImg: DAYEONSmallImage,
  },
  {
    name: "WAANO",
    smallImg: WannoSmallImage,
  },
];
